export const INITIAL_STATE = 'initial'
export const PROGRESS_STATE = 'progress'
export const FINISHED_STATE = 'finished'
